import clsx from "clsx"
import { FC, memo } from "react"
import { Trans } from "react-i18next"
import { IDeckReshuffledLog } from "@/store/apis/gameplayAPI"
import styles from "./LogDeckReshuffled.module.scss"

const LogDeckReshuffledComponent: FC<IDeckReshuffledLog> = (props) => {
  return (
    <span className={clsx(styles.LogEffectApplied)}>
      <Trans
        i18nKey="logs.deckReshuffled"
        components={{ span: <span className="green" /> }}
        values={{
          newDeckSize: props.details.newDeckSize
        }}
      />
    </span>
  )
}

export const LogDeckReshuffled = memo(LogDeckReshuffledComponent)
